const NavLinks = {
  CLUB_RENEWAL_ROOT: '/clubrenewal',
  CLUB_RENEWAL_SELECTION: '/clubrenewal/selection',
  CLUB_RENEWAL_RENEW: '/clubrenewal/renew'
};

export default NavLinks;